import React from "react";
import wobnr from "../../assets/imgs/bnrW.jpg";
import bnr2 from "../../assets/imgs/bnr2.jpg";
import bnr3 from "../../assets/imgs/bnr3.jpg";
import { NavLink } from "react-router-dom";
import "./BannerSection.css";
import "../../assets/css/app.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination,Autoplay} from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { motion } from "framer-motion";

function BannerSection({ onViewMoreClick }) {
  return (
    <motion.div
    initial={{ opacity: 0, y: 50 }} 
    animate={{ opacity: 1, y: 0 }} 
    transition={{ duration: 0.6, ease: "easeOut" }} 
  >
    <div className="banner-section">
      <Swiper
        modules={[ Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 15000,
          disableOnInteraction: false,
        }}
        className="mySwiper"
        loop={true} 
      >
       
        <SwiperSlide>
          <div className="Bnrs">
            <div className="bimgWrap">
              <img src={wobnr} alt="women-bnr" />
            </div>
            <div className="maxW">
             <div className="bnrWrpss">
             <h1>EXPLORE OUR FULL COLLECTION EVERYTHING YOU NEED, ALL IN ONE PLACE.</h1>
             <button className="vibtn lrnmre" onClick={onViewMoreClick}>
                      VIEW MORE
         </button>
             </div>
            </div>
          </div>
        </SwiperSlide>
        
        <SwiperSlide>
        <div className="Bnrs">
  <div className="bimgWrap">
    <img src={bnr2} alt="pratham-style" />
  </div>
  <div className="maxW">
    <div className="bnrWrpss">
      <div className="overlay">
      </div>
      <h1>EXPLORE YOUR STYLE WITH PRATHAM STYLE.</h1>
        <button className="vibtn lrnmre" onClick={onViewMoreClick}>
                      VIEW MORE
         </button>
    </div>
  </div>
</div>

        </SwiperSlide>

        <SwiperSlide>
          <div className="Bnrs">
            <div className="bimgWrap">
              <img src={bnr3} alt="collection" />
            </div>
            <div className="bnrWrpss">
            <div className="maxW">
              <h1>FIND THE ULTIMATE COLLECTION, TAILORED FOR YOU.</h1>
            </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    </motion.div>
  );
}

export default BannerSection;
